export const COULDNT_FIND_RECORDS = 'We couldn’t find any matches for "{{searchText}}"';
export const COULDNT_FIND_RECORDS_FILTERS = 'We couldn’t find any matches for your filters.';
export const COULDNT_FIND_RECORDS_DESC = "Can't find what you're looking for?";
export const COULDNT_FIND_RECORDS_REQUEST_DATA = 'Request a new data feed';
export const TABLE_ERROR = 'Something went wrong';
export const TABLE_ERROR_DESCRIPTION = 'Try reloading the page or try again in a couple of minutes';
